import { Component } from "../../core/Component";
export class BoxTextComponent extends Component {
  // static className = "qform-row";
  constructor($root, options) {
    super($root, options);

    /* if (options.fieldAlign) {
      $root.$el.classList.add(`fieldAlign-${options.fieldAlign}`);
    }
    if (options.formStyle.labelsPosition && options.formStyle.labelsPosition !== false) {
      $root.$el.classList.add(
        `labelsPosition-${options.formStyle.labelsPosition}`
      );
    } */
    /* if(typeof options.classes === "string" && options.classes.length > 0) {
      $root.$el.classList.add(`wrap-${options.classes}`)
    } */
    this.fieldId = options.id;
    this.label = options.label || "";
    this.text = options.text || "";
    this.hint = options.hint || "";
    this.classes = options.classes || "";
    // установка пользовательских классов оформления
    // this.setUserClasses()
    this.wrapClasses = this.makeWrapUserClasses();
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formIndex}`;
  }
  toHTML() {
    return `
    <div class="qform-field ${this.wrapClasses?.join(' ') || ''}">
      <div class="qform-field__textblock">
        <label class="qform-field__textblock_label">${this.label}</label>
        <div class="qform-field__textblock_text ${this.classes}">${this.text}</div>
      </div>
    </div>
    `;
  }
  init() {
    super.init();
  }
  validation() {
    return true;
  }
}